jQuery(function($) {
	$('[href^="#"]').click(function() {
		var id = $(this).attr('href').replace('#', '');
		$('html, body').animate({
			scrollTop: $('[id="' + id + '"], [name="' + id + '"]').offset().top
		}, 500);
	});
});